module.exports = __webpack_public_path__ + "img/facebook-20x20.e05f119b.svg";